export default __webpack_public_path__ + "static/media/quality.cee6c022.svg";